import { Box } from '@mui/material';

export const StatusDot = ({ color }: { color: string }) => {
  return (
    <Box
      sx={{
        width: 10,
        height: 10,
        borderRadius: '50%',
        bgcolor: color,
      }}
    />
  );
};
